import { render, staticRenderFns } from "./reservationListItem.vue?vue&type=template&id=491de6f8&scoped=true&"
import script from "./reservationListItem.vue?vue&type=script&lang=ts&"
export * from "./reservationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./reservationListItem.vue?vue&type=style&index=0&id=491de6f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491de6f8",
  null
  
)

export default component.exports